import axios from 'axios';
import { API_BASE_URL, API_URLS } from '../config/constants';

const categoryService = {
  // Get all categories
  getAllCategories: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.CATEGORIES}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get category by ID
  getCategoryById: async (categoryId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.CATEGORY_BY_ID(categoryId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new category
  createCategory: async (categoryData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}${API_URLS.CATEGORIES}`, categoryData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update category
  updateCategory: async (categoryId, categoryData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${API_URLS.CATEGORY_BY_ID(categoryId)}`, categoryData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete category
  deleteCategory: async (categoryId) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}${API_URLS.CATEGORY_BY_ID(categoryId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Add to existing categoryService
  getActiveCategories: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.CATEGORIES}`);
      // Filter active categories for dropdown
      return response.data.data.filter(category => category.is_active);
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update category status
  updateCategoryStatus: async (categoryId, isActive) => {
    try {
      const response = await axios.patch(`${API_BASE_URL}${API_URLS.CATEGORY_STATUS(categoryId)}`, {
        is_active: isActive
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};



export default categoryService;